import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import './index.scss'
import { IconClose, IconPhoneCallStroke, IconPhoneCircleBrand } from '../../../assets/icons'

const DEFAULT_PHONE = '02433886798'
const DEFAULT_PHONE_DISPLAY = '024 3388 6798'
const DEFAULT_SUPPORT_HOURS = '8:30 - 17:30 (T2-T6)'

export default function SupportCenterPopup({
  open = false,
  onClose = () => {},
  phone = DEFAULT_PHONE,
  phoneDisplay = DEFAULT_PHONE_DISPLAY,
  supportHours = DEFAULT_SUPPORT_HOURS
}) {
  useEffect(() => {
    if (!open) return undefined

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open || typeof document === 'undefined') return null

  return createPortal(
    <div className="SupportCenterPopup" role="dialog" aria-modal="true" aria-labelledby="SupportCenterPopup_title">
      <button type="button" className="SupportCenterPopup_overlay" aria-label="Đóng trung tâm hỗ trợ" onClick={onClose}></button>

      <div className="SupportCenterPopup_sheet">
        {/* <div className="SupportCenterPopup_handle"></div> */}

        <div className="SupportCenterPopup_header">
          <div className="SupportCenterPopup_title" id="SupportCenterPopup_title">
            Trung tâm hỗ trợ
          </div>

          <button type="button" className="SupportCenterPopup_close" aria-label="Đóng popup hỗ trợ" onClick={onClose}>
            <IconClose />
          </button>
        </div>

        <div className="SupportCenterPopup_body">
          <div className="SupportCenterPopup_contact">
            <div className="SupportCenterPopup_contact_icon">
              <IconPhoneCircleBrand />
            </div>
            <div className="SupportCenterPopup_contact">
              <div className="SupportCenterPopup_contact_text">
                Gọi tổng đài TAMOVE (8:30 - 17:30 từ Thứ 2 đến Thứ 6) để nhận hỗ trợ nhanh về chính sách dịch vụ và các vấn đề tra cứu giao thông.
              </div>
            </div>

            {/* <div className="SupportCenterPopup_contact_content">
              <div className="SupportCenterPopup_contact_text">
                Hotline hỗ trợ: {phoneDisplay} (miễn phí)
              </div>

              <div className="SupportCenterPopup_contact_time">
                <IconClock className="SupportCenterPopup_contact_timeIcon" />
                8:30 - 17:30 (T2-T6)
              </div>
            </div> */}
          </div>

          <a className="SupportCenterPopup_action" href={`tel:${phone}`}>
            <IconPhoneCallStroke className="SupportCenterPopup_action_icon" />
            <span>Gọi tổng đài {phoneDisplay}</span>
          </a>
        </div>

        {/* <div className="SupportCenterPopup_homeIndicator"></div> */}
      </div>
    </div>,
    document.body
  )
}

